module.exports = __webpack_public_path__ + "img/list_icon.51a11c43.png";